import { render, staticRenderFns } from "./MensagensVetoPorEnteFederativo.vue?vue&type=template&id=87c9ed22&scoped=true"
import script from "./MensagensVetoPorEnteFederativo.vue?vue&type=script&lang=js"
export * from "./MensagensVetoPorEnteFederativo.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MensagensVetoPorEnteFederativo.vue?vue&type=style&index=1&id=87c9ed22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c9ed22",
  null
  
)

export default component.exports